import {FC, useState} from 'react';
import {Box} from '@mui/material';
import ChangePasswordModalStep1 from './ChangePasswordModalStep1';
import ChangePasswordModalStep2 from './ChangePasswordModalStep2';
import ChangePasswordModalStep3 from './ChangePasswordModalStep3';
import {IOrganization, ITeam} from '@/utils/types';
import {useAppSelector} from '@/store/hooks';
import {getOrganizationSelector, getTeamSelector} from '@/store/organization/selector';
import {toast} from 'react-toastify';
import {getErrorMessage} from '@/utils/helpers';
import {UserService} from '@/utils/services';
import {AxiosInstance} from 'axios';

interface ConfirmationModalProps {
  onCloseModal: () => void;
  apiInstance: AxiosInstance;
}

enum Steps {
  STEP_1,
  STEP_2,
  STEP_3,
}

const ConfirmationModal: FC<ConfirmationModalProps> = ({onCloseModal, apiInstance}) => {
  const [formStep, setFormStep] = useState(Steps.STEP_1);

  const handleSubmitStep1 = async (values: {password: string}) => {
    try {
      await UserService.verifyOldPassword({oldPassword: values.password}, apiInstance);
      setFormStep(Steps.STEP_2);
    } catch (error) {
      toast.error(getErrorMessage(error));
    }
  };

  // const organization: IOrganization | null = useAppSelector(getOrganizationSelector);
  // const team: ITeam | null = useAppSelector(getTeamSelector);

  const handleSubmitStep2 = async (values: {password: string; confirmPassword: string}) => {
    // const id = organization?.ownerUserId ?? team?.userId;
    // if (!id) return;

    // if ((organization && organization?.id) || (team && team?.userId)) {
    const params = {
      changingPassword: values.password,
      confirmChangePassword: values.confirmPassword,
    };
    try {
      await UserService.setNewPassword(params, apiInstance);

      setFormStep(Steps.STEP_3);
    } catch (error) {
      toast.error(getErrorMessage(error));
      // }
    }
  };

  switch (formStep) {
    case Steps.STEP_1:
      return (
        <Box sx={{width: '100%'}}>
          <ChangePasswordModalStep1 onCloseModal={onCloseModal} handleSubmit={handleSubmitStep1} />
        </Box>
      );
    case Steps.STEP_2:
      return (
        <Box sx={{width: '100%'}}>
          <ChangePasswordModalStep2 onCloseModal={onCloseModal} handleSubmit={handleSubmitStep2} />
        </Box>
      );
    case Steps.STEP_3:
      return (
        <Box sx={{width: '100%'}}>
          <ChangePasswordModalStep3 onCloseModal={onCloseModal} />
        </Box>
      );
    default:
      return (
        <Box>
          <ChangePasswordModalStep1 onCloseModal={onCloseModal} handleSubmit={handleSubmitStep1} />
        </Box>
      );
  }
};

export default ConfirmationModal;
